'use client'
import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { noto_sans } from '@/globalConstants'
import { ShubhKarya } from '@/globalTypes'
import { getAllShubhKaryas } from '@/services/app.services'
import Skeleton from '@mui/material/Skeleton/Skeleton'
import Link from 'next/link'
import Image from 'next/image'
import PageBanner from '@/components/PageBanner'
import { usePathname } from 'next/navigation'

// Lazy load the BreadCrumb component only when needed
const BreadCrumb = dynamic(() => import('@/components/BreadCrumb'), { ssr: false });

// Optimized SubhKaryas component
const SubhKaryas = () => {
  const [subhKaryas, setSubhKaryas] = useState<ShubhKarya[]>([])
  const [isClient, setIsClient] = useState(false);
  const BASE_CLASS = 'shubh-karya'
  const pathname = usePathname();

  useEffect(() => {
    // Check if code is running on the client side
    setIsClient(typeof window !== 'undefined');
  }, []);

  useEffect(() => {
    (async () => {
      if (subhKaryas.length === 0) {
        const fetchedKaryas = await getAllShubhKaryas();
        setSubhKaryas(fetchedKaryas);
      }
    })()
  }, [subhKaryas]);

  return (
    <div>
      <PageBanner
        breadcrumb={<BreadCrumb pathname={pathname} />}
        title={'Shubh Dina'}
        subtitle={'Select Shubh Karya to see dates'}
        align="center"
      />
      <div className='mb-20'></div>
      <div className={`${BASE_CLASS} w-screen min-h-screen`}>
        <section className={`${BASE_CLASS}`}>
          <div className={`${BASE_CLASS}__panchanga pt-[1rem] pb-[4rem] flex justify-center`}>
            <div className='panchanga-container w-[95%] md:w-[90%] 2xl:w-[70%]'>
              <div className={`${BASE_CLASS}__shubh-karya grid md:grid-cols-2 lg:grid-cols-3 gap-[1rem] md:gap-[1.5rem] 2xl:grid-cols-3`}>
                {subhKaryas.length > 0 ? (
                  subhKaryas.map((subhKarya) => (
                    <Link
                      key={subhKarya.key}
                      href={`/shubh-dina/${subhKarya.key.trim().replaceAll('_', '-')}`}
                      className='no-underline'>
                      <div className={`${BASE_CLASS}__card rounded h-[84px] py-[1rem] px-[10px] lg:h-[166px] py-[1.5rem] px-[1rem] bg-white hover:bg-[#FFEEBB] rounded-[12px] border-[1px] cursor-pointer`}>
                        <div className={`${BASE_CLASS}__card__container flex items-center h-full gap-[12px] lg:grid md:gap-[10px]`}>
                          <div className={`${BASE_CLASS}__icon`}>
                            <Image src={subhKarya.icon_url} width={48} height={48} alt={`${subhKarya.display_name}_icon`} />
                          </div>
                          <div className='flex flex-row justify-between items-center w-full'>
                            <p className={`${BASE_CLASS}__subtext ${noto_sans.className} text-[#3C3838] font-[600] text-left lg:text-[20px]`}>
                              {subhKarya.display_name}
                            </p>
                            <Image src="/arrow-orange.svg" alt="arrow right" width={20} height={20} className="mb-1" />
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))
                ) : (
                  [...Array(9)].map((_, index) => (
                    <div key={index} className={`${BASE_CLASS}__card rounded h-[84px] py-[1rem] px-[10px] lg:h-[200px] py-[1.5rem] px-[1rem] bg-white rounded-[8px] border-[1px] cursor-pointer`}>
                      <div className={`${BASE_CLASS}__card__container flex items-center gap-2`}>
                        <div className={`${BASE_CLASS}__icon w-[48px] h-[50px]`}>
                          <Skeleton variant='circular' animation="wave" width={48} height={48} />
                        </div>
                        <div className={`${BASE_CLASS}__subtext ${noto_sans.className} h-[60px] grow`}>
                          <Skeleton variant='text' animation="wave" width={'100%'} height={60} />
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default SubhKaryas
